<template>
  <div id="publishing-journal-add">
    <div class="ipub-h1 mar-b-30">Add New Journal</div>
    <ipub-form ref="journal-add-form-first"
               :model="params"
               :rules="rules">
      <ipub-form-item prop="fullName"
                      label="Journal’s Full Name">
        <ipub-input v-model.trim="params.fullName"
                    placeholder="Journal’s Full Name" />
      </ipub-form-item>
      <ipub-row :gutter="20">
        <ipub-col :span="6">
          <ipub-form-item prop="name"
                          label="Journal’s Abbreviation">
            <ipub-input v-model.trim="params.name"
                        placeholder="Journal’s Abbreviation" />
          </ipub-form-item>
        </ipub-col>
        <ipub-col :span="6">
          <ipub-form-item prop="nameDatabase"
                          label="Journal’s Abbreviation (Database)">
            <ipub-input v-model.trim="params.nameDatabase"
                        placeholder="Journal’s Abbreviation (Database)" />
          </ipub-form-item>
        </ipub-col>
      </ipub-row>
      <!-- <ipub-form-item prop="contactEmail"
                      label="Contact Email">
        <ipub-input v-model.trim="params.contactEmail"
                    placeholder="Contact Email" />
      </ipub-form-item> -->
      <ipub-form-item prop="info"
                      label="Introduction (Max 100 words limited)">
        <ipub-editor :height="340"
                     v-model="params.info" />
      </ipub-form-item>
    </ipub-form>
    <div class="btns">
      <ipub-button plain
                   style="width:150px"
                   @click="()=>{$router.back(-1)}"
                   type="primary">Go Back</ipub-button>
      <ipub-button style="width:150px;"
                   @click="submit(false)"
                   type="primary">Next</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
